import { combineReducers } from 'redux'; // Importing function to combine multiple reducers

// reducer import
import customizationReducer from './customizationReducer'; // Importing the customization reducer

// ==============================|| COMBINE REDUCER ||============================== //

// Combine all reducers into a single root reducer
const reducer = combineReducers({
    customization: customizationReducer // Assign customization state slice to customizationReducer
});

export default reducer; // Export the combined reducer as default
